/*
 * @Author: shiguang
 * @Date: 2023-04-28 11:51:00
 * @LastEditors: yusha
 * @LastEditTime: 2024-07-30 13:38:41
 * @Description: interceptors
 */
import { message } from 'antd';
import gray from '@sniff/gray/dist/index.esm';
import { api, apiInstanceList } from '@/service';
import { ENUM_SYSTEM_SOURCE } from '@/const/enum';
import Code from '@/i18n/locales/code.json';
import { Site, getCountryByNavigatorLang } from '@/const';
import { Lang, getLang } from '@/i18n/init';
import { user } from '@/model/CustomerDetail';
import { serviceConfig } from './swaggerServiceConfig';
export const apiTag = '20240325-calc';
export const getEnv = () => {
    let _env: 'local' | 'prod' | 'master' | 'test01' | 'test02' | 'test03' =
        'prod';
    const [env, host] = window.location.host.split('-');
    if (window.location.port) {
        _env = 'local';
    } else if (host) {
        _env = env as typeof _env;
    }
    return _env as typeof _env;
};
export interface User {
    loginInfo: {
        userId: string;
        username: string;
    };
    userInfo: {};
    auth: never[];
    token: string;
}
const graify = gray(serviceConfig.baseURL);
export const getToken = () => {
    const tokenStr = window.localStorage.getItem('production_route/token');
    try {
        const token = JSON.parse(tokenStr ?? '{}').val as User;
        if (!token) return;
        return token;
    } catch (e) {
        return undefined;
    }
};

export const getShopId = () => {
    const shopStr = window.localStorage.getItem('production_route/curShop');
    if (!shopStr) return;
    try {
        const token = JSON.parse(shopStr).val as any;
        return token;
    } catch (e) {
        return undefined;
    }
};
/** B2B/D2C 切换 */
export const togglePlat = (systemSource: number) => {
    const plat = systemSource === ENUM_SYSTEM_SOURCE.D2C ? 'D2C' : 'B2B';
    window.document.documentElement.setAttribute('theme', plat ?? 'D2C');
};

/**
 * admin 端
 */
export const getUserInLocal = () => {
    const usrStr = window.localStorage.getItem('user');
    if (!usrStr) return;
    try {
        const user = JSON.parse(usrStr).user as User;
        return user;
    } catch (e) {
        return undefined;
    }
};

const translateByRspCode = (msgCode: string) => {
    const isLogin = !!getToken();
    /** 后端接口返回code,前端翻译 */
    let stationCode =
        localStorage.getItem('stationCode') || getCountryByNavigatorLang();
    // 为了解决在client端未登录，去切换语言，后端报错的提示语语言不对的问题
    // 如果没有登录，一切看缓存里面的语言信息
    if (!isLogin) {
        stationCode = getCountryByNavigatorLang();
    }
    const stationCodeMapLocal =
        {
            [Site.JP]: Lang.ja_JP,
            [Site.KR]: Lang.ko_KR,
            [Site.UK]: Lang.en_GB
        }[stationCode] || '';
    return (
        Code[stationCodeMapLocal][msgCode] ?? Code[stationCodeMapLocal].noMatch
    );
};

apiInstanceList.forEach((item) => {
    // 请求拦截
    item.instance.instance.interceptors.request.use(async function (config) {
        config.headers = config.headers ?? {};
        const isPost = ['POST', 'post'].includes(config.method!);
        const token = getToken();
        const shopId = getShopId();
        if (token) {
            config.headers['X-Authtoken'] = token;
        }
        if (shopId) {
            config.headers['X-Authshopid'] = shopId;
        }
        config.headers['X-Platform'] = 'PC';
        // 应用名称
        config.headers['X-Appname'] = 'ckb-oem-client';
        if (process.env.REACT_APP_X_GRAY_TAG) {
            config.headers['X-GRAY-TAG'] = process.env.REACT_APP_X_GRAY_TAG;
        }
        if (user.getState()?.stationCode) {
            config.headers['X-Stationcode'] = user.getState()?.stationCode;
        }
        config.headers['X-GRAY-TAG'] = apiTag;
        // if (isPost) {
        //     if (!config.data && config.params) {
        //         config.data = config.params;
        //     }
        //     config.params = {};
        //     config.headers['Content-Type'] = 'application/json';
        // }
        if (config['useMock']) {
            const queryPath = (config.baseURL! + config.url!).replace(
                // eslint-disable-next-line no-useless-escape
                /https{0,1}:\/\/[^\/]+/,
                ''
            );
            config.headers['Mock-Query-Path'] = queryPath;
            config.baseURL =
                'http://192.168.201.56:8093/functions/v1/mockapi' + queryPath;
            config.url = '';
        }
        await graify(config);
        return config;
    });
    // https://test01-s.theckb.com/login
    // 返回拦截
    item.instance.instance.interceptors.response.use(
        function (response) {
            if (response.data instanceof Blob) return response;
            if (response.data?.code === '0' && response.data.success === true) {
                return response;
            }
            if (response.data?.code === '10000000') {
                if (!window.location.pathname.endsWith('/login')) {
                    window.location.pathname =
                        getEnv() === 'local' ? '/oem/dev/login' : '/login';
                }
            }
            // if (response.data.code === 401) {
            //     if (!window.location.pathname.endsWith('/login')) {
            //         // 跳转登陆
            //         window.location.pathname = `/user/login`;
            //     }
            //     return Promise.reject(response.data.msg);
            // }
            // message.error(String(response.data.msg));

            const errorMsg = translateByRspCode(response.data.code);
            message.error(errorMsg);
            return Promise.reject(errorMsg);
        },
        function (error) {
            // message.error(String(error));
            return Promise.reject(error);
        }
    );
});

export const request = api;
